import type { SlotsGeneral } from 'www/api/types'
import {
  format,
  isToday,
  isTomorrow,
  parse,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import getFirstLetterUpper from 'www/utils/get/getFirstLetterUpper'

type Item = {
  date: string
  title: string
  subtitle: string
  label: string
  disabled: boolean
}

const now = new Date()

export default function getDateItemsFromSlots(slots: SlotsGeneral, locale = ru) {
  return Object.entries(slots).map(([date, value]) => {
    const dateParsed = parse(date, 'yyyy-MM-dd', now)

    let label = ''

    if (isToday(dateParsed)) {
      label = 'Сегодня'
    } else if (isTomorrow(dateParsed)) {
      label = 'Завтра'
    }

    return {
      date,
      title: format(dateParsed, 'd MMM', { locale }).replace('.', ''),
      subtitle: getFirstLetterUpper(format(dateParsed, 'EEEEEE', { locale })),
      label,
      disabled: !value.length,
    }
  }).reduce((result, currentItem, currentIndex, initialItems) => {
    if (!currentIndex) {
      result.push(currentItem)
      return result
    }

    if (currentIndex < initialItems.length) {
      if (!currentItem.disabled) {
        result.push(currentItem)
        return result
      }

      const nextItem = initialItems[currentIndex + 1] as Item | undefined
      const lastAddedItem = result[result.length - 1]

      if (nextItem?.disabled) {
        if (!lastAddedItem.disabled) {
          result.push(currentItem)
        }
      } else if (lastAddedItem.disabled) {
        const [firstDay, firstMonth] = lastAddedItem.title.split(' ')
        const [, secondMonth] = currentItem.title.split(' ')

        if (firstMonth === secondMonth) {
          lastAddedItem.title = `${firstDay}–${currentItem.title}`
        } else {
          lastAddedItem.title = `${lastAddedItem.title} – ${currentItem.title}`
        }

        lastAddedItem.subtitle = `${lastAddedItem.subtitle}–${currentItem.subtitle}`
        lastAddedItem.label = ''
      } else {
        result.push(currentItem)
      }
    }

    return result
  }, [] as Item[])
}
